export default __webpack_public_path__ + "static/media/Frame33.06802a0e.png";